import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IAllFoundPoints,
  IClusterInfo,
  IListLegalForm,
  IPoint,
  ISearchParamName,
  ISelectATE,
  SearchTabReducer,
} from 'types/mainPage';

const initialSelectItem = {
  label: '',
  id: 0,
};

const initialClusterInfo = {
  info: '',
  coordinates: [],
  gid: '',
};

const initialState: SearchTabReducer = {
  currentATE: initialSelectItem,
  currentParam: initialSelectItem,
  paramNames: [],
  selectATE: [],
  searchRequest: '',
  searching: false,
  listLegalForms: [],
  currentLegalForm: [],
  listActivities: [],
  currentActivity: [],
  foundPoints: [],
  allFoundPoints: [],
  clusterInfo: initialClusterInfo,
};

export const searchTabSlice = createSlice({
  initialState,
  name: 'searchTab',
  reducers: {
    setSelectAte(state, action: PayloadAction<ISelectATE[]>) {
      state.selectATE = action.payload;
    },
    setCurrentAte(state, action: PayloadAction<ISelectATE>) {
      state.currentATE = action.payload;
    },
    setParamNames(state, action: PayloadAction<ISearchParamName[]>) {
      state.paramNames = action.payload;
    },
    setCurrentParam(state, action: PayloadAction<ISearchParamName>) {
      state.currentParam = action.payload;
    },
    setSearchRequest(state, action: PayloadAction<string>) {
      state.searchRequest = action.payload;
    },
    setSearching(state, action: PayloadAction<boolean>) {
      state.searching = action.payload;
    },
    setLists(
      state,
      action: PayloadAction<{
        legalForm: IListLegalForm[];
        activities: IListLegalForm[];
      }>
    ) {
      state.listLegalForms = action.payload.legalForm;
      state.listActivities = action.payload.activities;
    },
    setCurrentLegalForm(state, action: PayloadAction<number[]>) {
      state.currentLegalForm = action.payload;
    },
    setCurrentActivity(state, action: PayloadAction<string[]>) {
      state.currentActivity = action.payload;
    },
    setFoundPoints(state, action: PayloadAction<IPoint[]>) {
      state.foundPoints = action.payload;
    },
    setAllFoundPoints(state, action: PayloadAction<IAllFoundPoints[]>) {
      state.allFoundPoints = action.payload;
    },
    setClusterInfo(state, action: PayloadAction<IClusterInfo>) {
      state.clusterInfo = action.payload;
    },
    updateOnlyClusterInfo(state, action: PayloadAction<string>) {
      state.clusterInfo = { ...state.clusterInfo, info: action.payload };
    },
    resetClusterInfo(state) {
      state.clusterInfo = initialClusterInfo;
    },
    resetBEData(state) {
      state.foundPoints = [];
      state.allFoundPoints = [];
      state.currentActivity = [];
      state.currentLegalForm = [];
      state.searchRequest = '';
    },
    resetSearchBlock() {
      return initialState;
    },
  },
});

export default searchTabSlice.reducer;
